const photos = [
  {
    src: "https://i.ibb.co/R6QSKfm/g3marketing.png",
    width: 100,
    height: 120,
  },
  {
    src: "https://i.ibb.co/pQYFWVC/gridiron.png",
    width: 100,
    height: 120,
  },
  {
    src: "https://i.ibb.co/Fm9s7hN/Home-Oracons.png",
    width: 100,
    height: 120,
  },
  {
    src: "https://i.ibb.co/0fthbQz/https-propertyobsession-net.png",
    width: 90,
    height: 120,
  },
  {
    src: "https://i.ibb.co/61gZPjb/Lake-Tahoe-Experience-Lake-Tahoe-Experience.png",
    width: 120,
    height: 120,
  },
  {
    src: "https://i.ibb.co/19bHdGx/meridianbioscience.png",
    width: 140,
    height: 120,
  },
  {
    src: "https://i.ibb.co/FbKzygZ/Mohegan-Sun-Experience-Mohegan-Sun-Experience.png",
    width: 110,
    height: 120,
  },
  {
    src: "https://i.ibb.co/5TcMFx1/paitson.png",
    width: 120,
    height: 120,
  },
  {
    src: "https://i.ibb.co/CnS9pMr/pgfansweeps.png",
    width: 140,
    height: 120,
  },
  {
    src: "https://i.ibb.co/RcN77wK/Pony-Xpress-Delivery-Services-Columbus-Cleveland-OH-Pony-Xpress-Delivery.png",
    width: 150,
    height: 120,
  },
  {
    src: "https://i.ibb.co/SvdTG83/pricechoppergiftcard.png",
    width: 90,
    height: 120,
  },
  {
    src: "https://i.ibb.co/zf6NrSY/Price-Chopper-Gift-Card-Price-Chopper-Gift-Card.png",
    width: 80,
    height: 120,
  },
  {
    src: "https://i.ibb.co/bz7nV4k/qca.png",
    width: 80,
    height: 120,
  },
  {
    src: "https://i.ibb.co/DYHQ3RJ/reflektions.png",
    width: 90,
    height: 120,
  },
  {
    src: "https://i.ibb.co/5W5vccw/Simple-truth-Water-Hand-Out-College.png",
    width: 100,
    height: 120,
  },
  {
    src: "https://i.ibb.co/v1PTCs5/Simple-Truth-Youth.png",
    width: 110,
    height: 120,
  },
  {
    src: "https://i.ibb.co/PNcdSvY/Smart-Fi-Earn-Trade-Borrow-Crypto-Easily.png",
    width: 80,
    height: 120,
  },
  {
    src: "https://i.ibb.co/1XPDDNc/Supercross.png",
    width: 120,
    height: 120,
  },
  {
    src: "https://i.ibb.co/mqrN7vS/Sureste-Property-Group.png",
    width: 120,
    height: 120,
  },
  {
    src: "https://i.ibb.co/BzzFkFL/tricountries.png",
    width: 95,
    height: 120,
  },
  {
    src: "https://i.ibb.co/ZWMfJ00/tune-registry.png",
    width: 90,
    height: 120,
  },
  {
    src: "https://i.ibb.co/L9wKmqF/turbine-college.png",
    width: 110,
    height: 120,
  },
  {
    src: "https://i.ibb.co/74ccNxb/Welcome-to-Pro-Camps-the-Nationwide-Leader-in-Youth-Sports-Camps.png",
    width: 130,
    height: 120,
  },
  {
    src: "https://i.ibb.co/N9htssV/Apreso.png",
    width: 140,
    height: 120,
  },
];

export default photos;
